import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from "ngx-infinite-scroll";//上拉下拉
import { FooterRefreshModule } from "../component/footer-refresh/footer-refresh.module";//加载和刷新
import { LazyLoadImageModule } from 'ng-lazyload-image';//图片懒加载
import { SROrderDetailComponent } from '../SR-order-detail/SR-order-detail.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot([{ path: 'srOrderDetail', component: SROrderDetailComponent }]),
        InfiniteScrollModule,
        FooterRefreshModule,
        LazyLoadImageModule,
    ],
    exports: [],
    declarations: [
        SROrderDetailComponent
    ],
    providers: [],
})
export class SROrderDetailModule { }